<div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
  <div class="flex justify-between gap-2">
    <div class="flex flex-wrap items-center gap-2">
      <tasks-task-data-target (click)="navigateToMemberProfile()">
        <mat-icon icon>account_circle</mat-icon>
        <span text>{{ task.data.memberName }}</span>
      </tasks-task-data-target>
      @if (memberUserId(); as userId) {
        <tasks-task-data-target (click)="openCoverage(userId)">
          <mat-icon icon>verified_user</mat-icon>
          <span text>{{ "task.action.showCoverage" | translate }}</span>
        </tasks-task-data-target>
      }
    </div>
    <p class="font-normal text-neutral-300">{{ formatDate(task.createdAt, true) }}</p>
  </div>
  @if (task.data.notes) {
    <tasks-multiline-text
      class="text-neutral-500"
      [text]="task.data.notes"
    />
  }
</div>

@if (task.status !== taskStatus.Resolved) {
  <div class="relative flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex items-center justify-between">
      <h4>{{ "prescription.label.relatedSpecialist" | translate }}</h4>
      @if (saveError(); as error) {
        <span class="text-sm text-error-500">{{ error | translate }}</span>
      }
    </div>

    <section class="flex flex-col gap-2">
      <h5 class="text-sm font-semibold text-neutral-600">{{ "guaranteeV2.label.diagnosis" | translate }}</h5>
      @if (diagnosisSummary(); as summary) {
        <div class="flex flex-wrap items-center gap-2">
          <guarantees-diagnosis-chip
            [diagnosis]="summary"
            [showCaseState]="false"
          ></guarantees-diagnosis-chip>
          <button
            class="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-neutral-400 hover:bg-error-50 hover:text-error-600"
            type="button"
            [attr.aria-label]="'guaranteeV2.action.removeDiagnosis' | translate"
            [matTooltip]="'guaranteeV2.action.removeDiagnosis' | translate"
            (click)="removeDiagnosis()"
          >
            <mat-icon class="h-4! w-4! text-base! leading-4!">close</mat-icon>
          </button>
        </div>
      } @else {
        @for (key of [pickerKey()]; track key) {
          <guarantees-icd10-picker (selected)="addDiagnosis($event)"></guarantees-icd10-picker>
        }
        <p class="text-sm text-warning-800">{{ "guaranteeV2.label.noDiagnosesWarning" | translate }}</p>
      }
    </section>

    <section class="flex flex-col gap-2">
      @if (line(); as queued) {
        <div class="flex flex-wrap items-center gap-2 rounded-lg border border-neutral-200 px-2 py-1.5">
          <mat-icon
            class="h-4! w-4! shrink-0 text-base! leading-4! text-neutral-400"
            [matTooltip]="kindLabelKey[queued.prescription.kind] | translate"
            >{{ kindIcon[queued.prescription.kind] }}</mat-icon
          >
          <span class="min-w-0 flex-1 truncate text-sm font-semibold text-neutral-700">{{ queued.prescription.name || queued.prescription.code }}</span>
          @if (queued.decision; as decision) {
            <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-700">
              <mat-icon class="h-3! w-3! shrink-0 text-xs! leading-3!">{{ decisionIcon[decision.answer] }}</mat-icon>
              {{ decisionLabelKey[decision.answer] | translate }}
            </span>
          } @else {
            <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-warning-100 px-2 py-0.5 text-xs font-semibold text-warning-800">
              <mat-icon class="h-3! w-3! shrink-0 text-xs! leading-3!">warning</mat-icon>
              {{ "guaranteeV2.label.decisionPending" | translate }}
            </span>
          }
          <button
            class="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-600"
            type="button"
            [attr.aria-label]="'guaranteeV2.action.editLine' | translate"
            [matTooltip]="'guaranteeV2.action.editLine' | translate"
            (click)="openLineForm()"
          >
            <mat-icon class="h-4! w-4! text-base! leading-4!">edit</mat-icon>
          </button>
          <button
            class="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-neutral-400 hover:bg-error-50 hover:text-error-600"
            type="button"
            [attr.aria-label]="'guaranteeV2.action.deleteLine' | translate"
            [matTooltip]="'guaranteeV2.action.deleteLine' | translate"
            (click)="removeLine()"
          >
            <mat-icon class="h-4! w-4! text-base! leading-4!">close</mat-icon>
          </button>
        </div>
      } @else {
        <div
          class="flex cursor-pointer items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-neutral-300 p-6 text-neutral-300 hover:border-neutral-400 hover:bg-neutral-100 hover:text-neutral-400"
          (click)="openLineForm()"
        >
          <span class="my-0.5">{{ "guaranteeV2.action.addPrescription" | translate }}</span>
          <mat-icon>add</mat-icon>
        </div>
      }
    </section>

    <mat-form-field class="w-full">
      <mat-label>{{ "prescription.label.guaranteeDescription" | translate }}</mat-label>
      <textarea
        matInput
        [formControl]="descriptionFc"
      ></textarea>
    </mat-form-field>

    <div class="flex justify-end">
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="!canSubmit() || descriptionFc.invalid"
        (click)="submit()"
      >
        {{ "prescription.action.createGuaranteeApplication" | translate }}
      </button>
    </div>

    @if (saving()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-neutral-0/80">
        <shared-loader />
      </div>
    }
  </div>
}
